export const apiCalling = {
    IS_LOADER_SHOW: "IS_LOADER_SHOW",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
}